import type { useSizeFilter } from './useSizeFilter'
import React from 'react'
import { NumberInput } from '@ztechapps/webui.input'
import toNumber from 'lodash/toNumber'
import { useReactiveState } from '@ztechapps/common.hook'
import { useDebounce } from 'react-use'

export const SizeNumberInput = ({ value, onChange, maximumValue, step }: Partial<ReturnType<typeof useSizeFilter>>) => {
  const [localValue, setLocalValue] = useReactiveState(value)
  const [wasChanged, setWasChanged] = React.useState(false)

  useDebounce(
    () => {
      if (!wasChanged) return

      onChange(localValue)
      setWasChanged(false)
    },
    1500,
    [localValue]
  )

  const onKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onChange(localValue)
    }
  }

  return (
    <NumberInput
      value={localValue?.mid ?? ''}
      onChange={(e) => {
        setLocalValue({ mid: toNumber(e.target.value) })
        setWasChanged(true)
      }}
      max={maximumValue}
      min={0}
      step={step}
      onKeyDown={onKeydown}
    />
  )
}
